"use client";
import {
  FileArchive,
  History,
  LockKeyhole,
  X,
} from "lucide-react";
import {
  type HistoryItem,
} from "../../../lib/types";
import {
  formatDate,
  truncateMiddle,
} from "../../shared/format";
import {
  IconButton,
} from "../../shared/primitives";
import {
  verdictTone,
} from "../../shared/verdict";


export function HistoryView({
  history,
  clearHistory,
  removeHistory,
}: {
  history: HistoryItem[];
  clearHistory: () => void;
  removeHistory: (id: string) => void;
}) {
  return (
    <section className="panel history-panel">
      <div className="panel-heading">
        <div>
          <div className="section-kicker">THIS BROWSER</div>
          <h3>Recent scan summaries</h3>
        </div>
        {history.length > 0 && (
          <button className="danger-text-button" type="button" onClick={clearHistory}>
            Clear history
          </button>
        )}
      </div>
      <div className="history-note">
        <LockKeyhole size={14} />
        Only report summaries are stored. Archive contents and extracted secrets
        are never written to history.
      </div>
      {history.length ? (
        <div className="history-list">
          {history.map((item) => (
            <div key={`${item.id}-${item.completedAt}`}>
              <span className={`history-verdict tone-${verdictTone(item.verdict)}`}>
                <FileArchive size={17} />
              </span>
              <span className="history-file">
                <strong>{item.fileName}</strong>
                <code>{truncateMiddle(item.sha256, 16, 10)}</code>
              </span>
              <span>
                <small>Verdict</small>
                <strong>{item.verdict}</strong>
              </span>
              <span>
                <small>Risk</small>
                <strong>{item.score}/100</strong>
              </span>
              <span>
                <small>Findings</small>
                <strong>{item.findings}</strong>
              </span>
              <span>
                <small>Scanned</small>
                <strong>{formatDate(item.completedAt)}</strong>
              </span>
              <IconButton
                label={`Remove ${item.fileName} from history`}
                onClick={() => removeHistory(item.id)}
              >
                <X size={14} />
              </IconButton>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-panel history-empty">
          <History size={28} />
          <strong>No local scan history</strong>
          <span>Completed analyses will appear here.</span>
        </div>
      )}
    </section>
  );
}
